import { PopularTrendingTokensResponse } from "@cede/types";
import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useQuery } from "@tanstack/react-query";

const POPULAR_TOKENS_STALE_TIME = 24 * 60 * 60 * 1000; // 24 hours

export const usePopularTokens = () => {
  const apiHelper = useApi();

  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.POPULAR_TOKENS],
    staleTime: POPULAR_TOKENS_STALE_TIME,
    retry: false,
    queryFn: async (): Promise<{ response: PopularTrendingTokensResponse; symbols: string[] }> => {
      try {
        const response = await apiHelper.getOrThrow(API_ENDPOINT.HUB_TRADE_POPULAR_TOKENS);
        const symbols = (response.tokens || []).map((token) => token.symbol);
        return { response, symbols };
      } catch {
        // Swallow errors and return empty payload so UI doesn't break
        return {
          response: { tokens: [], updatedAt: new Date().toISOString() },
          symbols: [],
        };
      }
    },
  });

  return {
    popularTokens: data?.response?.tokens ?? [],
    popularSymbols: data?.symbols ?? [],
    updatedAt: data?.response?.updatedAt,
    isLoading,
    error,
  };
};
